import { useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Text,
  IconButton,
  useDisclosure,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";

export default function DisclaimerPopup() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Define handleClose to use for both auto-close and manual close
  const handleClose = () => {
    sessionStorage.setItem("disclaimerShown", "true");
    onClose();
  };

  useEffect(() => {
    // Check if disclaimer already shown in this session
    const hasSeenDisclaimer = sessionStorage.getItem("disclaimerShown");

    if (!hasSeenDisclaimer) {
      onOpen();

      // Auto-close after 3 seconds
      const timer = setTimeout(() => {
        handleClose();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [onOpen]);

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay
        bg="blackAlpha.700"
        backdropFilter="blur(8px)"
      />

      <ModalContent
        bg="rgba(15,8,37,0.95)"
        border="1px solid rgba(167,139,250,0.4)"
        borderRadius="2xl"
        p={4}
        position="relative"
        mx={4}
      >
        {/* Close Button */}
        <IconButton
          aria-label="Close disclaimer"
          icon={<CloseIcon boxSize={3} />}
          size="sm"
          position="absolute"
          top="12px"
          right="12px"
          variant="ghost"
          color="white"
          _hover={{ bg: "whiteAlpha.200" }}
          onClick={handleClose}
        />

        <ModalBody textAlign="center">
          <Text
            fontSize="2xl"
            fontWeight="bold"
            bgGradient="linear(to-r, #8B5CF6, #D946EF)"
            bgClip="text"
            mb={4}
          >
            Disclaimer
          </Text>

          <Text color="gray.300" fontSize="18px" lineHeight="1.6">
            Winnsta is a skill-based gaming platform. <br />
            This is not a real-money gambling. <br />
            Please play responsibly and ensure you comply with your local laws.
          </Text>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}